export default __webpack_public_path__ + "static/media/Arjun.8b0034a8.png";